import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [statusMessage, setStatusMessage] = useState('');

  const handleNewsletterSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypotVal = (formData.get('website_alt') as string || '').trim();

    if (honeypotVal !== '') {
      setStatus('success');
      setStatusMessage('Vielen Dank für Ihre Anmeldung!');
      return;
    }

    setStatus('loading');
    try {
      const res = await fetch('https://readdy.ai/api/form/d9bldl6c87cp3jcuj2og', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email }).toString(),
      });
      const text = await res.text();
      let parsed: Record<string, unknown> = {};
      try { parsed = JSON.parse(text); } catch { /* ignore */ }
      const serverMsg = (parsed?.meta as Record<string, unknown>)?.message as string || parsed?.message as string || text;

      if (res.ok && (parsed?.code === 'OK')) {
        setStatus('success');
        setStatusMessage('Vielen Dank für Ihre Anmeldung!');
        setEmail('');
      } else {
        setStatus('error');
        setStatusMessage(typeof serverMsg === 'string' ? serverMsg : 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.');
      }
    } catch {
      setStatus('error');
      setStatusMessage('Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.');
    }
  };

  return (
    <footer className="relative bg-foreground-900 mx-4 md:mx-6 mb-4 md:mb-6 rounded-3xl overflow-hidden">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2.5 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-pie-chart-line text-background-50 text-base"></i>
              </div>
              <span className="font-heading text-background-50 text-lg font-semibold">
                OOPBUY Spreadsheet
              </span>
            </Link>
            <p className="text-foreground-300 text-sm leading-relaxed">
              Der unabhängige Informationsguide zum OOPBUY Spreadsheet. Wir verkaufen keine Produkte und sind nicht offiziell mit OOPBUY verbunden.
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 rounded-full bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors" aria-label="Twitter">
                <i className="ri-twitter-x-line text-background-50 text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors" aria-label="Reddit">
                <i className="ri-reddit-line text-background-50 text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors" aria-label="YouTube">
                <i className="ri-youtube-line text-background-50 text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-background-50 text-sm font-semibold mb-4">Kategorien</h4>
            <ul className="space-y-2.5">
              <li><a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-foreground-300 text-sm hover:text-background-50 transition-colors">Schuhe</a></li>
              <li><a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-foreground-300 text-sm hover:text-background-50 transition-colors">Hoodies & Pullover</a></li>
              <li><a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-foreground-300 text-sm hover:text-background-50 transition-colors">T-Shirts</a></li>
              <li><a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-foreground-300 text-sm hover:text-background-50 transition-colors">Jacken</a></li>
              <li><a href="https://kaspreadsheet.com/search-915/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-foreground-300 text-sm hover:text-background-50 transition-colors">Hosen & Shorts</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 text-sm font-semibold mb-4">Guides</h4>
            <ul className="space-y-2.5">
              <li><Link to="/artikel/oopbuy-spreadsheet-guide" className="text-foreground-300 text-sm hover:text-background-50 transition-colors">OOPBUY Spreadsheet Guide</Link></li>
              <li><Link to="/artikel/oopbuy-spreadsheet-einkaufsguide" className="text-foreground-300 text-sm hover:text-background-50 transition-colors">Einkaufsguide</Link></li>
              <li><Link to="/artikel/oopbuy-spreadsheet-qc-guide" className="text-foreground-300 text-sm hover:text-background-50 transition-colors">QC Guide</Link></li>
              <li><Link to="/artikel/oopbuy-spreadsheet-versand-guide" className="text-foreground-300 text-sm hover:text-background-50 transition-colors">Versand Guide</Link></li>
              <li><Link to="/artikel/oopbuy-spreadsheet-vergleich" className="text-foreground-300 text-sm hover:text-background-50 transition-colors">Vergleich</Link></li>
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-foreground-300 text-sm hover:text-background-50 transition-colors">Buy it now</a></li>
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-foreground-300 text-sm hover:text-background-50 transition-colors">OOPBUY Spreadsheet</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 text-sm font-semibold mb-4">Newsletter</h4>
            <p className="text-foreground-300 text-sm leading-relaxed mb-4">
              Bleiben Sie auf dem Laufenden mit den neuesten OOPBUY Spreadsheet Updates.
            </p>
            <form onSubmit={handleNewsletterSubmit} data-readdy-form="true">
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="newsletter-honeypot"
              />
              <div className="flex flex-col gap-2.5">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Ihre E-Mail-Adresse"
                  required
                  className="w-full px-4 py-3 bg-foreground-800 border border-foreground-700 rounded-xl text-background-50 text-sm placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                />
                <button
                  type="submit"
                  disabled={status === 'loading'}
                  className="w-full px-4 py-3 bg-primary-500 text-background-50 text-sm font-semibold rounded-xl hover:bg-primary-600 transition-colors whitespace-nowrap disabled:opacity-60"
                >
                  {status === 'loading' ? 'Wird gesendet...' : 'Abonnieren'}
                </button>
              </div>
              {status === 'success' && (
                <p className="mt-2 text-primary-400 text-xs">{statusMessage}</p>
              )}
              {status === 'error' && (
                <p className="mt-2 text-red-400 text-xs">{statusMessage}</p>
              )}
            </form>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-400 text-xs">
            &copy; 2026 OOPBUY Spreadsheet Guide. Alle Rechte vorbehalten.
          </p>
          <p className="text-foreground-500 text-xs">
            Unabhängige Informationsressource – nicht offiziell mit OOPBUY verbunden.
          </p>
        </div>
      </div>
    </footer>
  );
}